<template>
    
    <div class="TTL-login-box">
        <div class="TTL-login-contain">
            <img src="@/assets/login/login-bgr.png" class="TTL-login-bgr" />
            <div class="TTL-login-input-box" ref="logins">

                <!-- 登录手机号码输入页面 -->
                <div class="TTL-login-input-main" v-if="ismore==0">
                    <div class="TTL-input TTL-username">
                        <el-input v-model="login.username" placeholder="请输入登录手机号码" clearable @keydown.enter.prevent="CheckManager" />
                    </div>
                    <div class="TTL-input TTL-password top15">
                        <el-input type="password" v-model="login.password" placeholder="请输入登录密码" clearable @keydown.enter.prevent="CheckManager" />
                    </div>
                    <div class="TTL-remember-me top15">
                        <div class="TTL-checkbox TTL-checkbox-login"><el-checkbox v-model="login.isremember" /></div>
                        <span class="TTL-remember-me-span">记住密码</span>
                    </div>
                    <div class="TTL-button TTL-button-login top25">
                        <el-button @click="CheckManager">登录</el-button>
                    </div>
                </div>

                <!-- 手机号码登录多管理员页面 -->
                <div class="TTL-login-manager-more" v-if="ismore==1">
                    <div class="TTL-login-more">
                        <div class="TTL-login-more-info" v-for="(item,index) in managerlist" :key="index" @click="submitLogin(item.id,item.shopid)">
                            <el-tooltip :content="item.shopname" placement="top">
                            <el-image :src="item.thumb ? item.thumb : require('@/assets/icon/manager-default.png')" fit="cover" class="TTL-login-more-img"/>
                            </el-tooltip>
                            <span class="TTL-login-more-info-span top10">{{item.shopname}}</span>
                            <span class="TTL-login-more-info-span-sub top05">{{item.name}}</span>
                        </div>  
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>


<script>
import INTERFACE_MODEL_LOGIN from '@/Interface/Login/login';
import cookies from 'js-cookie';
export default {
    data() {
        return {
           login: {
               username:cookies.get('username') ? cookies.get('username') : '',
               password:cookies.get('password') ? cookies.get('password') : '',
               isremember:cookies.get('isremember') ? true : false,
               loading:false,
           },
           managerlist:[],
           ismore:0,
        }
    },

    mounted() {
        
    },

    methods: {


        /**
         * 检测管理员账号是否存在
         * 
        */
       CheckManager() {
           this.$loading.openloading(this.$refs.logins); //加载loading
           if(this.login.username=='') {
                this.$notice({title:'错误提示',message:'请填写登录手机号码',type:'warning'});
                this.$loading.closeloading(this.$refs.logins); //关闭loading
                return false;
           }
           if(this.login.password=='') {
                this.$notice({title:'错误提示',message:'请填写用户登录密码',type:'warning'});
                this.$loading.closeloading(this.$refs.logins); //关闭loading
                return false;
           }
           
           //调用登录接口处理
           this.login.loading=true;
           INTERFACE_MODEL_LOGIN.CHECK_LOGIN_MANAGER(this.login).then((res) => {
                 this.$loading.closeloading(this.$refs.logins); //关闭loading
                 if(res.status > 0) return false;
                 
                 //获取数据信息
                 var data=res.data;
                 if(data.length==1) {
                     this.submitLogin(data[0].id,data[0].shopid);
                 }else {
                     this.managerlist=data;
                     this.ismore=1;
                 }

             });

       },



        /**
         * 管理员登录
         */
         submitLogin(id,shopid) {
             //调用登录接口处理
             this.login.loading=true;
             INTERFACE_MODEL_LOGIN.LOGIN({id:id,shopid:shopid}).then((res) => {
                 if(res.status > 0) return false;

                 //回调数据进行处理
                 this.saveLogins(this.login,res.data);
             });
         },


        /**
         * 处理登录返回的回调信息
         */
        saveLogins(info,res) {
            if(info.isremember) { //保存登录信息
                cookies.set('username',info.username); //设置登录账号
                cookies.set('password',info.password); //设置登录密码
                cookies.set('isremember',true); //是否保存登录信息
            }else { //不保存登录信息
                cookies.set('username',''); //设置登录账号
                cookies.set('password',''); //设置登录密码
                cookies.set('isremember',false); //是否保存登录信息
            }

            cookies.set('token',res.token ? res.token : ''); //设置token
            localStorage.setItem('managerlists',JSON.stringify(this.managerlist)); //存储管理员信息
            localStorage.setItem('managers',JSON.stringify(res)); //存储管理员信息
            localStorage.setItem('shops',JSON.stringify(res.shop)); //存储管理员信息
            localStorage.setItem('shopid',res.shop.id); //存储店铺id
            localStorage.setItem('managerid',res.id); //存储管理员id
            localStorage.setItem('groupid',res.groupid); //存储角色id   
            localStorage.setItem('level',res.shop.level); //存储角色id   
            this.$router.push('/');
        },


    },

}
</script>